import { FC } from "react";
import { FormField } from "@epcnetwork/core-ui-kit";

import { HashTypesEnum } from "pages/pipelines/forms/reverse/reverse.types";

const hashOptions = [
  { value: HashTypesEnum.md5, label: "MD5" },
  { value: HashTypesEnum.sha256, label: "SHA256" },
];

export const HashTypes: FC = () => {
  return (
    <>
      <FormField type="radio" name="fileValues.hashType" options={hashOptions} disableError />
      <br />
    </>
  );
};
